<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Leaves</span>
      <h1 class="hris-page-title">Leaves History</h1>
      <p class="hris-page-subtitle">Search and export employee leave records.</p>
    </div>

    <q-form v-if="isAdmin" @submit="onSubmit" class="hris-toolbar">
      <div class="hris-form-field" style="flex: 1 1 280px; max-width: 350px;">
        <q-input outlined dense color="green" type="text" v-model="employeeID" label="Search Employee ID" :rules="[formRules.required]" ></q-input>
      </div>
      <div class="hris-form-field" style="flex: 0 1 200px; max-width: 200px;">
        <q-select outlined dense color="green" v-model="year" :options="years" label="Years" :rules="[formRules.required]" ></q-select>
      </div>
      <q-btn unelevated class="hris-q-primary" label="Search History" type="submit" ></q-btn>
    </q-form>

    <div class="hris-panel">
      <q-table flat :data="data" :columns="columns" row-key="id">
        <q-tr slot="body" slot-scope="props" :props="props">
          <q-td key="leaveType" :props="props">{{ props.row.leaveType }}</q-td>
          <q-td key="fromDate" :props="props">{{ props.row.fromDate }}</q-td>
          <q-td key="toDate" :props="props">{{ props.row.toDate }}</q-td>
          <q-td key="total" :props="props">{{ props.row.total }}</q-td>
          <q-td key="reason" :props="props">{{ props.row.reason }}</q-td>
          <q-td key="status" :props="props">
            <span
              class="hris-badge"
              :class="props.row.status == 'Pending' ? 'hris-badge-warning' : props.row.status == 'Approved' ? 'hris-badge-success' : props.row.status == 'Done' ? 'hris-badge-success' : props.row.status == 'Declined' ? 'hris-badge-danger' : 'hris-badge-neutral'"
            >
              {{ props.row.status }}
            </span>
          </q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="dept" :props="props">{{ props.row.dept }}</q-td>
          <q-td key="position" :props="props">{{ props.row.position }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No result found</div>
        </template>
        <template v-slot:top-right>
          <div class="row q-gutter-sm">
            <q-btn
              unelevated
              class="hris-q-outline"
              label="Export to Excel"
              no-caps
              @click="exportTable('xlsx')"
            />
            <q-btn
              unelevated
              class="hris-q-primary"
              label="Export to CSV"
              no-caps
              @click="exportTable('csv')"
            />
          </div>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 200px;">
        <q-spinner color="green" size="3em" />
        <div>Loading history</div>
      </div>
    </q-dialog>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { exportFile } from 'quasar'
import vueCookies from 'vue-cookies';

function wrapCsvValue (val, formatFn, row) {
  let formatted = formatFn !== void 0
    ? formatFn(val, row)
    : val

  formatted = formatted === void 0 || formatted === null
    ? ''
    : String(formatted)

  formatted = formatted.split('"').join('""')
  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')

  return `"${formatted}"`
}

export default {
  data () {
    return {
        years: [],
        year: new Date().getFullYear(),
        employeeID: '',
        columns: [
        { name: 'leaveType', align: 'center', label: 'Leave Type', field: 'leaveType'},
        { name: 'fromDate', align: 'center', label: 'From Date', field: 'fromDate'},
        { name: 'toDate', align: 'center', label: 'To Date', field: 'toDate' },
        { name: 'total', align: 'center', label: 'Total Days', field: 'total' },
        { name: 'reason', align: 'center', label: 'Reason', field: 'reason' },
        { name: 'status', align: 'center', label: 'Status', field: 'status' },
        { name: 'name', align: 'center', label: 'Name', field: 'name' },
        { name: 'dept', align: 'center', label: 'Department', field: 'dept' },
        { name: 'position', align: 'center', label: 'Position', field: 'position' },
      ],
      data: [],
      spinner:false,
      isAdmin: false
   }
},

   created(){
      this.yearsList()
      if(vueCookies.get('sgcchris').user.username == 'admin'){
        this.isAdmin = true;
      }else{
        this.onSubmit();
      }
   },

  methods: {
      onSubmit () {
          this.spinner = true;
          let formData = new FormData();

          if(vueCookies.get('sgcchris').user.employee_id !== 'admin'){
            formData.append("employeeID", vueCookies.get('sgcchris').user.employee_id);
          }else{
            formData.append("employeeID", this.employeeID);
          }
          formData.append("year", this.year);

          axios.create({
              baseURL : this.apiUrl,
              headers : {'Authorization' : `Bearer ${this.token}`}
          }).post('/leave/history',formData)
          .then((res) => {
              this.data = res.data.data
              this.spinner = false
          });

      },

      exportTable (fileExtension) {
        // naive encoding to csv format
        const content = [ this.columns.map(col => wrapCsvValue(col.label)) ].concat(
          this.data.map(row => this.columns.map(col => wrapCsvValue(
            typeof col.field === 'function'
              ? col.field(row)
              : row[col.field === void 0 ? col.name : col.field],
            col.format
          )).join(','))
        ).join('\r\n')

        const status =  exportFile(
          `SLVLRemainingReport.${fileExtension}`,
          content,
          `text/${fileExtension}`
        );

        if (status !== true) {
          this.$q.notify({
            message: 'Browser denied file download...',
            color: 'negative',
            icon: 'warning'
          })
       }
    },

   yearsList : function(){
      axios.create({
        baseURL : this.apiUrl,
        headers : {'Authorization' : `Bearer ${this.token}`}
      }).post(`/timekeeping/years/list`)
      .then((res) => {
        this.years = res.data.data
      });
   },

  },
}
</script>
